import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { authApi } from '@xtnd/web/features/auth/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const isAuthenticated = authApi.isAuthenticated();

  if (!isAuthenticated) {
    // Prevent redirect loops - only set 'from' state if we're not already on login page
    const shouldSetFromState = location.pathname !== '/login';
    const redirectState = shouldSetFromState ? { from: location } : null;

    return <Navigate to="/login" state={redirectState} replace />;
  }

  return <>{children}</>;
}
